import { render, staticRenderFns } from "./SamplingInformation.vue?vue&type=template&id=6fa8fe08"
import script from "./SamplingInformation.vue?vue&type=script&lang=js"
export * from "./SamplingInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports